// Local selectors for open additional account :
import { createStructuredSelector } from 'reselect';

// fetching makeAContributionReducer
export const fetchLocalReducer = (store) => store.contributionActivity;

// fetching API Data from reducer
export const fetchActivityData = (state) => {
    const { data } = fetchLocalReducer(state);
	return data ? data.Activity : [];
};
const fetchWholeActivityData = (state) => {
    const { data } = fetchLocalReducer(state);
	return data ? data.WholeActivity : [];
};

// Status filter data
export const fetchStatusFilter = (state) => {
    const { statusFilterData } = fetchLocalReducer(state);
	return statusFilterData;
};
const fetchWholeStatusFilter = (state) => {
    const { statusFilterData } = fetchLocalReducer(state);
	return statusFilterData.WholeActivity;
};

export const fetchStatusFilterData = (state) => {
    const { data = null } = fetchStatusFilter(state);
	return data;
};

// Time frame filter data
export const fetchTimeFrame = (state) => {
    const {timeFrameData} = fetchLocalReducer(state);
	return timeFrameData;
};

// Time frame filter data
export const fetchTimeFrameData = (state) => {
    const { data = null } = fetchTimeFrame(state);
	return data;
};

// Drupal Data
export const fetchDrupalData = (state) => {
    const { drupalData } = fetchLocalReducer(state);
	return drupalData && drupalData.data;
};

export const fetchDrupalAlertData = (state) => {
    const { drupalData } = fetchLocalReducer(state);
	return drupalData && drupalData.alert;
};

export const fetchStatusDropdownValue = (state) => {
    const { status } = fetchLocalReducer(state);
    return status.value ? status.value : [];
};

export const selectViewContributionData = (state) => {
    const { viewContribution } = fetchLocalReducer(state);
    return viewContribution.data;
};

export const fetchDropdownData = (state) => {
    const { dropDownData } = fetchLocalReducer(state);
    return dropDownData.data;
};

export const fetchVCDrupalData = (state) => {
    const { viewContributionDrupal } = fetchLocalReducer(state);
    return viewContributionDrupal.data;
};

export const fetchFilteredData = (state) => {
    const { filteredData } = fetchLocalReducer(state);
    return filteredData.Activity;
};

const fetchLoadMoreFlag = (state) =>{
    const { loadMoreFlag } = fetchLocalReducer(state);
    return loadMoreFlag;
}
// MainPage
export const CAMainPageState =  createStructuredSelector({
    contributionData: fetchActivityData,
    contributionWholeData:fetchWholeActivityData,
    statusFilterData: fetchStatusFilter,
    statusFilterWholeData:fetchWholeStatusFilter,
    timeFrameData: fetchTimeFrame,
    drupalData: fetchDrupalData,
    filteredData:fetchFilteredData,
    loadMore:fetchLoadMoreFlag
});

// Contribution Search Mobile
export const contributionSearchMobileState = createStructuredSelector({
    contributionData: fetchActivityData,
    contributionWholeData:fetchWholeActivityData,
    dropDownValues: fetchStatusDropdownValue,
    statusFilterData: fetchStatusFilterData,
    timeFrameData: fetchTimeFrameData
});

// Calender
export const calenderState = createStructuredSelector({
    contributionData: fetchActivityData,
    contributionWholeData:fetchWholeActivityData,
    statusFilterData: fetchStatusFilter,
    timeFrameData: fetchTimeFrame,
    loadMore:fetchLoadMoreFlag,

});

// View Contribution
export const viewContributionState = createStructuredSelector({
    transactionData: selectViewContributionData
});

// Confirmation processing details
export const confirmationProcessingDetailsState = createStructuredSelector({
    currentTransactionData: selectViewContributionData
});

// Contribution Type
export const contributionTypeState = createStructuredSelector({
    contributionTypes: selectViewContributionData,
    dropDownData: fetchDropdownData
})

// Funding instructions
export const fundingInstructionsState = createStructuredSelector({
    contributionTypes: selectViewContributionData,
    dropDownData: fetchDropdownData,
    drupalData: fetchVCDrupalData
});

// Allocation
export const allocationState = createStructuredSelector({
    data: selectViewContributionData
});

// Contribution activity card
export const contributionActivityCardState = createStructuredSelector({
    contributionData: fetchFilteredData,
    contributionWholeData:fetchWholeActivityData,
    drupalData: fetchDrupalAlertData,
    loadMore:fetchLoadMoreFlag,
    timeFrameData: fetchTimeFrame
});

// contribution activity Table
export const contributionActivityTableState = createStructuredSelector({
    contributionData: fetchFilteredData,
    contributionWholeData:fetchWholeActivityData,
    drupalData: fetchDrupalAlertData,
    loadMore:fetchLoadMoreFlag,
    timeFrameData: fetchTimeFrame

});

// contribution search
export const contributionSearchState = createStructuredSelector({
    dropDownValues: fetchStatusDropdownValue
});

// select
export const selectState = createStructuredSelector({
    dropDownValues: fetchStatusDropdownValue
});

// TimeFrameComponent

export const timeFrameComponentState = createStructuredSelector({
    contributionData: fetchActivityData,
    contributionWholeData:fetchWholeActivityData,
    statusFilterData: fetchStatusFilter,
    timeFrameData: fetchTimeFrame,
    loadMore:fetchLoadMoreFlag
});
